<div id="#modal" class="uhc-modal-box">
  <div class="uhc-modal-header">
    <h4 class="uhc-h4">{{title}}</h4>
    <span fxFlex="90" fxLayoutAlign="end center">
      <a href="javascript:void(0)" (click)="close()" title="Click here to close {{title}} page"
        *ngIf="!isPendingNotice && !isBulkPendingApproval && !isUpdateCoverage  && !isArchivedStudents && !isArchivedStudentsOk && !isHeldClaims">
        <img src="../../../../assets/images/close-icon.png" alt="Close Icon" />
      </a>
    </span>
  </div>
  <div class="uhc-modal-content" [ngStyle]="{ 'text-align' : isHeldClaims ? 'start' : 'center'}">
    <p [innerHTML]="message"></p>
  </div>
  <div class="uhc-modal-footer"
    *ngIf="!isPendingNotice && !isBulkPendingApproval && !isUpdateCoverage && !isArchivedStudents && !isHeldClaims">
    <button class="uhc-button uhc-primary" (click)="ok()">Ok</button>
  </div>
  <div class="uhc-modal-footer" *ngIf="isPendingNotice">
    <button class="uhc-button uhc-primary" (click)="pendingDataCall()">Yes</button>
    <button class="uhc-button" (click)="closePendingPopup()">No, Maybe later</button>
  </div>
  <div class="uhc-modal-footer" *ngIf="isBulkPendingApproval || isUpdateCoverage ">
    <button class="uhc-button" (click)="close()">Cancel</button>
    <button class="uhc-button uhc-primary" *ngIf="isBulkPendingApproval " (click)="BulkPendingCoverage()">Ok</button>
    <button class="uhc-button uhc-primary" *ngIf="isUpdateCoverage " (click)="UpdateCoverage()">Ok</button>
  </div>
  <div class="uhc-modal-footer" *ngIf="isArchivedStudents">
    <button class="uhc-button" (click)="close()">Cancel</button>
    <button class="uhc-button uhc-primary" (click)="ArchivedStudents()">Ok</button>
  </div>
  <div class="uhc-modal-footer" *ngIf="isHeldClaims">
    <button class="uhc-button uhc-primary" (click)="reviewNow()">Review Now</button>
    <button class="uhc-button" (click)="close()">Cancel</button>
  </div>
</div>
